import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '../LazyWidgets/Card';
import BigText from '../LazyWidgets/BigText';
import Modal from '../LazyWidgets/Modal';
import style from './HeroCard.module.css';
import sButton from '../MLButton/MLButton.module.css';
import MLButton from '../MLButton/MLButton';


class HeroCard extends Component {
  static propTypes = {
    className: PropTypes.string,
    reportUrl: PropTypes.string,
    heroData: PropTypes.array,
    heroTitle: PropTypes.string,
    activeModuleTitle: PropTypes.string,
    modalTitle: PropTypes.string,
    modalContent: PropTypes.object,
    buttonText: PropTypes.string,
    showModuleReportButton: PropTypes.bool,
    nullStateMessage: PropTypes.object,
    showNullStateMessage: PropTypes.bool,
    nullStateTitle: PropTypes.object,
    onTabChange: PropTypes.func,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.heroData !== prevState.heroData) {
      return {
        heroData: nextProps.heroData,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    const { heroData, heroTitle } = props;

    this.state = {
      heroData,
      heroTitle,
    };
  }

  getModalComponent() {
    return (
      <Modal
        trigger={
          <button className={style.activeReportLink} role="link">
            How is this calculated?
          </button>}
      >
        <Modal.Header>
          <p className={style.activeReportModalHeader}>{this.props.modalTitle}</p>
        </Modal.Header>
        <Modal.Content id="my-modal-id" className={style.activeReportModalContent}>
          {this.props.modalContent}
        </Modal.Content>
      </Modal>
    );
  }

  getIndividualItem(item, index) {
    return (
      <div className={item.className} key={index}>
        {index !== 0 && <div className={style.activeReportCalculationDivider} />}
        {index !== 0 && <hr className={style.activeHorizontalDivider} />}
        <div className={style.activeReportCalculationColumn} style={item.style}>
          {item.title && <div className={style.activeReportCalculationTitleWrapper}>
            <div className={style.activeReportCalculationTitle}>{item.title}</div>
          </div>}
          <BigText
            className={style.activeReportCalculationNumber}
            text={item.text}
            smallText={item.smallText || ''}
          />
          {item.isAverage && <div className={style.activeReportCalculationTitle}>Average Score</div>}
          {item.bottomText && <div className={style.activeReportCalculationTitle}>{item.bottomText}</div>}
        </div>
      </div>
    );
  }

  render() {
    const {
      reportUrl,
      showModuleReportButton,
      showNullStateMessage,
      nullStateMessage,
      className,
      activeModuleTitle,
      onTabChange,
      buttonText,
    } = this.props;

    const { heroData, heroTitle } = this.state;
    return (
      <Card className={className}>
        {!showNullStateMessage &&
        <div>
          <div>
            {activeModuleTitle ?
              <h2 className={style.titleModuleActive}>{heroTitle}
                <span className={style.titleNameModuleActive}>{activeModuleTitle}</span>
              </h2>
            :
              <h2 className={style.titleNameModuleActive}>{heroTitle}</h2>
            }
            {this.getModalComponent()}
          </div>
          <div className={style.activeReportCalculation}>
            {heroData.map((item, index) => this.getIndividualItem(item, index))}
          </div>
        </div>
        }
        {showModuleReportButton && <div className={style.moduleReportFooterCard}>
          <MLButton
            ariaLabel={buttonText}
            btnText={buttonText}
            className={[style.viewBtn, sButton.btnSecondary].join(' ')}
            onClick={() => {
              onTabChange(reportUrl);
            }}
          />
        </div>
        }
        {(showNullStateMessage && nullStateMessage &&
          <div>
            <div className={style.cardHeader}>
              {activeModuleTitle ?
                <h2 className={style.titleModuleActive}>{heroTitle}
                  <span className={style.titleNameModuleActive}>None</span>
                </h2>
                :
                <h2 className={style.titleNameModuleActive}>{heroTitle}</h2>
              }
            </div>
            <div className={style.nullState}>
              {nullStateMessage}
            </div>
          </div>
        )}
      </Card>
    );
  }
}

export default HeroCard;
